import {languageFiles} from '../../config/constant'
//import enText from '../../app-text-files/enText.json'
export const languageSelector = (props) =>{
  let file = false, language = "en";
  //console.log("language selector props.guestLanguages",props.guestLanguages)
  if(props.guestLanguages){
    language = props.guestLanguages;
  } else if(props.hotelLanguage.preferredLanguageCode){
    language = props.hotelLanguage.preferredLanguageCode;
  } 
  
  if(language) {
    if(languageFiles[language]) {
      file = languageFiles[language].file;
    }
  }
  if(!file) {
    file = languageFiles["en"].file;
  }
  //console.log("language selector props.guestLanguages",file);
  return file;
}